import React, {Component} from "react";
import {Card, Page, List, Stack, Button, Link} from '@shopify/polaris';
import Cookies from 'js-cookie';
import SubmitIssue from "../SubmitIssue";

class ReviewUs extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isShowAskForReview: false,
      appNameCookie: `autoketing-review-${this.props.shopDomain}-${this.props.appName}`,
      submitIssueModal: false
    };
  }

  componentDidMount() {
    const cookieByAppName = Cookies.get(this.state.appNameCookie);
    if (!cookieByAppName) {
      // Show ask for review
      this.setState({isShowAskForReview: true});
    } else {
      switch (cookieByAppName) {
        case 'readyLeave':
          // console.log('ok ready leave');
          break;
        case 'feedback':
          // console.log('have a feedback');
          break;
        default:
          break;
      }
    }
  }

  noIHaveFeedBack = () => {
    this.setState({submitIssueModal: true});
  };

  readyToLeaveAReview = () => {
    Cookies.set(this.state.appNameCookie, 'readyLeave', {expires: 365});
    this.setState({isShowAskForReview: false});
  };

  closeSubmitModal = () => {
    this.setState({submitIssueModal: false});
  };

  successFeedBack = () => {
    // console.log('call when success feedback');
    // Cache two day if have a feedback
    Cookies.set(this.state.appNameCookie, 'feedback', {expires: 2});
    this.setState({isShowAskForReview: false});
  };

  render() {
    const appName = this.props.appName;
    let reviewUrl;
    switch (appName) {
      case 'fb-chat':
        reviewUrl = 'https://apps.shopify.com/facebook-chat-box?reveal_new_review=true';
        break;
      default:
        break;
    }

    let reviewContent = '';
    if (this.state.isShowAskForReview) {
      reviewContent = <Page>
        <Card title="Allow us to serve you best!"
              secondaryFooterAction={{content: 'No, I have a feedback', onAction: this.noIHaveFeedBack}}
              primaryFooterAction={{content: 'Yes, I leave a review', url: reviewUrl, external: true}}
              actions={[{content: 'I left a review', onAction: this.readyToLeaveAReview}]}>
          <Card.Section title="YOUR REVIEW IS OUR MOTIVATION AND WEALTH">
            <List>
              <List.Item>We truly believe that you have excellent ideas</List.Item>
              <List.Item>We aspire to meet all your needs, whether small or large</List.Item>
              <List.Item>It's hard to improve our app best without your help. We always wait for your review
                :)</List.Item>
            </List>
          </Card.Section>
        </Card>
      </Page>
    }

    return (
      <div>
        {reviewContent}
        <SubmitIssue successFeedBack={this.successFeedBack} closeSubmitModal={this.closeSubmitModal}
                     openModal={this.state.submitIssueModal}/>
      </div>
    )
  }
}

export default ReviewUs
